/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/function-component-definition */
/* eslint-disable comma-spacing */
import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { Divider, Drawer, Form, Radio } from 'antd';

import DrawerSubmitFooter from '../common/containers/DrawerSubmitFooter';
import OnTraccrNumberInput from '../common/inputs/OnTraccrNumberInput';
import OnTraccrRadioGroup from '../common/inputs/OnTraccrRadioGroup';
import PaginatedTable from '../common/containers/PaginatedTable';

import {
  currencyFormatter,
  currencyParser,
  markupPercentFormatter,
  percentParser,
  materialCostFormatter,
} from '../helpers/inputParsers';

import { getPreviewColumns } from './materialTableColumns';

import { changeIsNumber, MATERIAL_COST_MAX_DECIMALS } from './materialsHelpers';
import { convertLowerCamelCaseToText } from '../helpers/helpers';

export default ({
  type,
  costType = "material",
  visible,
  onClose,
  onSubmit,
  selected = [],
}) => {
  const isCost = type === 'Cost';
  const isMaterialCost = costType === 'material';
  const [change,setChange] = useState();
  const [changeMode, setChangeMode] = useState('dollar');

  const onSubmitClicked = useCallback(() => {
    onSubmit(change, isCost ? changeMode : undefined);
  },[change, changeMode, isCost, onSubmit]);

  const numberInputProps = useMemo(() => (
    (isCost && changeMode === 'dollar') ? {
      formatter: isMaterialCost ? materialCostFormatter : currencyFormatter,
      parser: currencyParser,
      precision: isMaterialCost ? MATERIAL_COST_MAX_DECIMALS : 2,
      step: isMaterialCost ? 0.00001 : 0.01,
    } : {
      formatter: markupPercentFormatter,
      parser: percentParser,
      precision: 5,
      step: 0.00001,
    }
  ),[isCost, changeMode, isMaterialCost]);

  const columns = useMemo(() => (
    getPreviewColumns({ type, costType, change, changeMode })
  ), [type, costType, change, changeMode]);
  const canSubmit = useMemo(() => changeIsNumber(change),[change]);

  useEffect(() => {
    if(!visible) {
      setChange();
      setChangeMode('dollar');
    }
  },[visible]);
  const title = type && costType ? `${convertLowerCamelCaseToText(costType)} ${convertLowerCamelCaseToText(type)}` : type;

  return (
    <Drawer
      title={`Change ${title} for ${selected.length} items`}
      width={800}
      visible={visible}
      onClose={onClose}
    >
      {isCost && (
        <Form.Item label='Change type'>
          <OnTraccrRadioGroup
            buttonStyle="solid"
            value={changeMode}
            onChange={setChangeMode}
          >
            <Radio.Button value="dollar">Dollar Amount ($)</Radio.Button>
            <Radio.Button value="percentage">Percentage (%)</Radio.Button>
          </OnTraccrRadioGroup>
        </Form.Item>
      )}
      <Form.Item label='Enter change'>
        <OnTraccrNumberInput
          style={{ width: '100%' }}
          {...numberInputProps}
          onChange={setChange}
          value={change}
        />
      </Form.Item>
      <Divider/>
      <PaginatedTable
        className='materials-table'
        scroll={{ x:'max-content' }}
        pagination={false}
        size='small'
        rowKey='id'
        columns={columns}
        dataSource={selected}
        scrollOffset={305}
      />
      <DrawerSubmitFooter
        onClose={onClose}
        onSubmit={onSubmitClicked}
        canSubmit={canSubmit}
      />
    </Drawer>
  )
}
